import { useTranslation } from "next-i18next";
import strftime from "strftime";
import { Get_SubscriptionQuery } from "gql/graphql";

import CustomerSupportMessage from "./CustomerSupportMessage";

export default function CancellationMessage({
  subscription,
}: {
  subscription: NonNullable<Get_SubscriptionQuery["subscription"]>;
}) {
  const { t } = useTranslation("common");

  return (
    <>
      <p className="mt-6 text-xs text-white/70">
        {t("cancellation_message", {
          date: strftime("%B %d, %Y", new Date(subscription.cancelAt)),
        })}
      </p>
      <CustomerSupportMessage />
    </>
  );
}
